import { render, staticRenderFns } from "./AddCragAscentBtn.vue?vue&type=template&id=47b4fcc7"
import script from "./AddCragAscentBtn.vue?vue&type=script&lang=js"
export * from "./AddCragAscentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports